import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const ConfigContext = createContext({
  config: { payment_mode: "stripe", logo_data_url: null },
  loading: true,
  reload: () => {},
});

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({ payment_mode: "stripe", logo_data_url: null });
  const [loading, setLoading] = useState(true);

  const reload = useCallback(() => {
    setLoading(true);
    return api
      .get("/config/public")
      .then((r) => setConfig(r.data || { payment_mode: "stripe", logo_data_url: null }))
      .catch(() => setConfig({ payment_mode: "stripe", logo_data_url: null }))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <ConfigContext.Provider value={{ config, loading, reload }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}
